import React from "react";
import { Money, btn, ScopeBadge } from "../lib/ui";
import { fmtDate } from "../lib/format";
import { localizeName } from "../lib/catI18n";
import { Trash2, Copy } from "lucide-react";

export const DuplicateReview = ({ groups, cats, accts, locale, t, onDelete, onResolve, onDedupe, dedupeLabel }) => {
  if (!groups.length)
    return <p className="text-sm text-[#5F8588] py-10 text-center" data-testid="dup-empty">{t("dup.empty")}</p>;
  const catName = (id) => { const c = cats.find((x) => x.id === id); return c ? localizeName(c.name, locale) : "—"; };
  const acctName = (id) => { const a = accts.find((x) => x.id === id); return a ? a.name : "—"; };
  return (
    <div className="flex flex-col gap-4" data-testid="dup-review-list">
      {groups.map((g) => (
        <div key={g.key} data-testid={`dup-group-${g.key}`} className="rounded-lg border border-[#D5E7E5] bg-white p-4">
          <div className="flex items-center gap-2 mb-3 text-sm font-bold text-[#075E62]">
            <Copy size={15} className="text-[#05787E]" /> {t("dup.groupTitle")} ({g.items.length})
          </div>
          <div className="grid sm:grid-cols-2 gap-3">
            {g.items.map((it) => (
              <div key={it.id} data-testid={`dup-item-${it.id}`} className="rounded-lg border border-[#D5E7E5] bg-[#F7FBFA] p-3 text-sm">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-[#075E62]"><Money amount={it.amount} currency={it.currency_code} type={it.type} /></span>
                  <ScopeBadge scope={it.scope} />
                </div>
                <dl className="grid grid-cols-2 gap-x-3 gap-y-1 text-xs text-[#5F8588]">
                  <dt>{t("mv.date")}</dt><dd className="text-[#075E62] text-right">{fmtDate(it.date)}</dd>
                  <dt>{t("mv.description")}</dt><dd className="text-[#075E62] text-right truncate">{it.description || "—"}</dd>
                  <dt>{t("mv.currency")}</dt><dd className="text-[#075E62] text-right">{it.currency_code}</dd>
                  <dt>{t("mv.account")}</dt><dd className="text-[#075E62] text-right">{acctName(it.account_id)}</dd>
                  <dt>{t("mv.category")}</dt><dd className="text-[#075E62] text-right">{catName(it.category_id)}</dd>
                  <dt>{t("mv.type")}</dt><dd className="text-[#075E62] text-right">{it.type === "income" ? t("mv.incomeOpt") : t("mv.expenseOpt")}</dd>
                </dl>
                <button onClick={() => onDelete(it)} data-testid={`dup-delete-${it.id}`} className="mt-3 inline-flex items-center gap-1.5 text-sm text-[#A85751] font-medium hover:underline">
                  <Trash2 size={14} /> {t("dup.deleteOne")}
                </button>
              </div>
            ))}
          </div>
          <div className="flex items-center gap-3 flex-wrap mt-3 pt-3 border-t border-[#D5E7E5]">
            {onDedupe && g.items.length >= 2 && <button onClick={() => onDedupe(g)} data-testid={`dup-dedupe-${g.key}`} className="inline-flex items-center gap-1.5 text-sm text-[#A85751] font-medium hover:underline"><Trash2 size={14} /> {dedupeLabel || t("dup.deleteOne")}</button>}
            <button onClick={() => onResolve(g)} data-testid={`dup-keep-${g.key}`} className={btn.outline}>{t("dup.keepBoth")}</button>
            <button onClick={() => onResolve(g)} data-testid={`dup-reviewed-${g.key}`} className={btn.ghost}>{t("dup.markReviewed")}</button>
            <button onClick={() => onResolve(g)} data-testid={`dup-ignore-${g.key}`} className={btn.ghost}>{t("dup.ignore")}</button>
          </div>
        </div>
      ))}
    </div>
  );
};
